import {
  TableHeaderDefinitionCellType,
  TableCell,
} from '~/components/organism/Table/types';
import { BaseHeaderCellOptions } from '../asBaseCell';
import { asBaseOptions } from '../asBaseCell';

export type NumberRenderFunction = (
  value: number,
  tableCell: TableCell<number>,
) => React.ReactNode;

type NumberHeaderCellOptions = BaseHeaderCellOptions & {
  renderFunction?: NumberRenderFunction;
};

const asNumberTableHeaderCell = ({
  renderFunction,
  ...rest
}: NumberHeaderCellOptions): TableHeaderDefinitionCellType<number> => {
  const renderFn =
    renderFunction == null
      ? (value: number, _tableCell: TableCell<number>) => value.toString()
      : renderFunction;

  const options = {
    ...asBaseOptions({ ...rest }),
    Cell: (tableCell: TableCell<number>) =>
      renderFn(tableCell.cell.value, tableCell),
  };

  return options;
};

export default asNumberTableHeaderCell;
